export const routes = ( prefix = `master-data` ) => [
    {
        path: `/${prefix}/voucher-deductions`,
        name: `${prefix}.voucher-deductions.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.voucher-deductions.index`,
                PageDescription: "Voucher Deduction listing/create",
            },
        },
    },
];